import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useRepsOutletContext } from 'pages/Reps.context'
import { useParams } from 'react-router-dom'
import { reps } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRep() {
    const { id } = useParams()
    const { data } = useRepsOutletContext()
    const r = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = reps.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!r) return null

    const handleSubmit = () =>
        mutateAsync(r.id, {
            onSuccess: () => {
                toast.success('Rep excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Reps']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o REP
                    {r.numeroSerie ? ` ${r.numeroSerie}` : ''}?
                </>
            }
        />
    )
}
